import { render, staticRenderFns } from "./BfScrollEffect.vue?vue&type=template&id=01c4ad71&scoped=true&"
import script from "./BfScrollEffect.vue?vue&type=script&lang=js&"
export * from "./BfScrollEffect.vue?vue&type=script&lang=js&"
import style0 from "./BfScrollEffect.vue?vue&type=style&index=0&id=01c4ad71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c4ad71",
  null
  
)

export default component.exports